import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import {MatToolbar, MatToolbarModule} from '@angular/material/toolbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { landingpageReducer } from './store/reducer/landingpage.reducer';
import { UserService } from './user.service';
import { UserEffects } from './store/effects/user.effects';
import {LandingpagePageComponent} from './components/landing-page/landingpage-page.component';
import { TranslateModule } from '@ngx-translate/core';
import {LandingCardComponent} from './components/landing-card/landing-card.component';
import {DashboardEffects} from './store/effects/dashboard.effects';
import {DashboardService} from './dashboard.service';
import {AddButtonFormdialogComponent} from './components/addButton-form-dialog/addButton-formdialog.component';
import { ColorPickerModule } from 'ngx-color-picker';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MatRadioModule} from '@angular/material/radio';
import {ZeiterfassungPageComponentModule} from '@src/app/pages/Zeiterfassung/zeiterfassung.module';
import {SharedModule} from '@src/app/shared.module';

@NgModule({
    imports: [
        StoreModule.forFeature('landingpage', landingpageReducer),
        EffectsModule.forFeature([UserEffects, DashboardEffects]),
        MatTableModule,
        CommonModule,
        TranslateModule,
        MatToolbarModule,
        FlexLayoutModule,
        MatListModule,
        MatCardModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        MatSortModule,
        ColorPickerModule,
        MatTooltipModule,
        TooltipModule,
        MatRadioModule,
        ZeiterfassungPageComponentModule,
        SharedModule,
    ],
    providers: [UserService, DashboardService],
    declarations: [
      LandingpagePageComponent,
      LandingCardComponent,
      AddButtonFormdialogComponent,
    ],
})
export class LandingpageModule {}
